/** Fallback until the resizable navbar reports its measured bottom edge. */
export const WEBDESIGNED_HEADER_HEIGHT_PX = 116;
